import React from 'react';

export default function ReviewStep({ formData, selectedRecordLabels }) {
  return (
    <div className="space-y-6">
      <h4 className="font-medium text-slate-900">Review Request</h4>
      <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm space-y-3">
        <div>
          <p className="text-xs uppercase tracking-wide text-slate-500">Provider</p>
          <p className="font-medium text-slate-900">{formData.providerName || 'Not set'}</p>
          <p className="text-slate-600">{formData.organization || 'Not set'}</p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-wide text-slate-500">Records</p>
          <p className="text-slate-900">
            {selectedRecordLabels.length > 0 ? selectedRecordLabels.join(', ') : 'None selected'}
          </p>
          {(formData.dateRangeStart || formData.dateRangeEnd) && (
            <p className="text-slate-600">
              Date range: {formData.dateRangeStart || 'Any'} to {formData.dateRangeEnd || 'Any'}
            </p>
          )}
        </div>
        <div>
          <p className="text-xs uppercase tracking-wide text-slate-500">Delivery</p>
          <p className="text-slate-900">{formData.deliveryMethod}</p>
          {formData.sendToAnotherProvider && (
            <>
              <p className="text-slate-600">
                From {formData.providerName || 'N/A'} ({formData.organization || 'N/A'})
              </p>
              <p className="text-slate-600">
                To {formData.destinationProviderName || 'N/A'} ({formData.destinationOrganization || 'N/A'})
              </p>
              <p className="text-slate-600">
                Send patient copy: {formData.sendCopyToUser ? 'Yes' : 'No'}
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
